import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconPersonRunningLeft(
  { srText, size = 'md', className = '', ...props }: Props,
) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id='person-running-left_svg__a'>
            <path d='M4 .707h7V7H4Zm0 0' />
          </clipPath>
          <clipPath id='person-running-left_svg__b'>
            <path d='M1.395 2H23.98v21.293H1.395Zm0 0' />
          </clipPath>
        </defs>
        <g clipPath='url(#person-running-left_svg__a)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.23529}
            d='M7.11 6.352a2.47 2.47 0 1 0 0-4.942 2.47 2.47 0 0 0-2.47 2.473 2.47 2.47 0 0 0 2.47 2.469m0 0'
          />
        </g>
        <g clipPath='url(#person-running-left_svg__b)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.23529}
            d='M19.625 9.156 19.98 12h-3.46l-3.172-3.176 2.465-2.472h2.945c.375 0 .734-.149.996-.414a1.413 1.413 0 0 0 0-1.996 1.4 1.4 0 0 0-.996-.41h-2.945a2.83 2.83 0 0 0-1.997.823L8.29 9.883H3.934c-.375 0-.735.148-.996.414a1.413 1.413 0 0 0 .996 2.41h4.355a2.85 2.85 0 0 0 1.996-.828l1.059-1.059 3.18 3.176v7.18c0 .375.148.734.41 1a1.43 1.43 0 0 0 1 .414 1.43 1.43 0 0 0 1-.414c.261-.266.41-.625.41-1v-6.352h2.636a2.83 2.83 0 0 0 2.118-.957c.265-.3.46-.652.578-1.035a2.8 2.8 0 0 0 .105-1.184l-.508-4.058'
          />
        </g>
        <path
          fill='none'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.23529}
          d='M14.523 13.996 16.52 12'
        />
      </svg>
    </>
  )
}
IconPersonRunningLeft.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconPersonRunningLeft
